import { TeaserCard } from '../models/teaser-card';

export const teaserCards: TeaserCard[] = [
    {
        imageUri: 'assets/img/astra_versicherung_schuelertabletversicherung_920x440.webp',
        headline: 'Tabletversicherung für die Schule',
        content:
            'Für Schüler, Lehrer und ganze Schulklassen: Umfassender Schutz bei \
            Diebstahl und Schäden in der Schule oder zuhause.',
        path: ['/', 'produkte', 'tablet-versicherung-plus', ''],
        showPriceFrom: true,
        period: 'month',
        pricePerPeriod: 1.99,
    },
    {
        imageUri: 'assets/img/astra_versicherung_handyversicherung_920x440.webp',
        headline: 'Handyversicherung',
        content:
            'Mit oder ohne Selbstbeteiligung: Weltweiter Schutz bei Diebstahl, \
            Wasser- oder Displayschäden. ',
        path: ['/', 'produkte', 'handyversicherung', ''],
        showPriceFrom: true,
        period: 'month',
        pricePerPeriod: 2.09,
    },
    {
        imageUri: 'assets/img/astra_versicherung_elektronikversicherung_920x440.webp',
        headline: 'Elektronikversicherung',
        content:
            'Der Schutz für nahezu alle privaten elektronischen Geräte: \
            Tablets, Smartwatch, Kamera, PC, Haushaltsgeräte uvm.',
        path: ['/', 'produkte', 'elektronikversicherung', ''],
        showPriceFrom: true,
        period: 'month',
        pricePerPeriod: 2.09,
    },
];
